import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
// https://redux.js.org/recipes/using-immutablejs-with-redux/#use-a-higher-order-component-to-convert-your-smart-components-immutablejs-props-to-your-dumb-components-javascript-props
import withImmutablePropsToJS from "with-immutable-props-to-js"

// components
import Dashboard from "app/static/frontend/dashboards/components/Dashboard"

// action creators
import { evaluateWidget, sendAction } from "shared/djangio/action-creators"
import { updateUserdata } from "shared/userdata/userdata-action-creators"

import { popPage, segueToUrl } from "app/static/frontend/global-action-creators"
import {
    createOrUpdateDashboard,
    destroyDashboardStore,
    initializeDashboard,
    loadDashboard,
    reconcileDashboardLayout,
    removeFromDashboardLayout,
    setDashboardsValues,
} from "app/static/frontend/dashboards/action-creators"
import { loadCustomRegions } from "app/static/frontend/subfeatures/RegionSelectionPage/action-creators"
import { submitWidgetTemplateSelection } from "app/static/frontend/dashboards/action-creators/widgetCreateFormActionCreators"

// selectors
import {
    selectDashboardId,
    selectDashboardsValue,
    selectIsExternal,
    selectIsHomepageDashboard,
    selectLayout,
} from "app/static/frontend/dashboards/selectors"
import { selectCustomRegions } from "app/static/frontend/subfeatures/RegionSelectionPage/selectors"

const mapStateToProps = createStructuredSelector({
    id: selectDashboardId,
    cachedWidgetData: selectDashboardsValue("cached_widget_data"),
    compactType: selectDashboardsValue("compactType"),
    creatingWidget: selectDashboardsValue("creatingWidget"),
    deletedWidgets: selectDashboardsValue("deletedWidgets"),
    editing: selectDashboardsValue("editing"),
    editingTeamPermissions: selectDashboardsValue("editingTeamPermissions"),
    external_custom_region_selection: selectDashboardsValue("external_custom_region_selection"),
    external_password: selectDashboardsValue("external_password"),
    external_slug: selectDashboardsValue("external_slug"),
    external_regions: selectDashboardsValue("external_regions"),
    externalDownloadsDisabled: selectDashboardsValue("externalDownloadsDisabled"),
    hasLoaded: selectDashboardsValue("hasLoaded"),
    isHomepageDashboard: selectIsHomepageDashboard,
    isLimitedToCreator: selectDashboardsValue("is_limited_to_creator"),
    isLoading: selectDashboardsValue("isLoading"),
    isLoadingDownload: selectDashboardsValue("isLoadingDownload"),
    isLoadingDownloadWidgets: selectDashboardsValue("isLoadingDownloadWidgets"),
    isRefreshing: selectDashboardsValue("isRefreshing"),
    isSaving: selectDashboardsValue("isSaving"),
    layout: selectLayout,
    limitedToTeams: selectDashboardsValue("limited_to_teams"),
    name: selectDashboardsValue("name"),
    widgets: selectDashboardsValue("widgets"),

    // isExternal will take care of whether we are visiting an external dashboard
    isExternal: selectIsExternal,
    // while is_external is the dashboard field about this being able to be shared
    is_external: selectDashboardsValue("is_external"),
    ...(window.location.pathname.includes("/external/") ? {} : { customRegions: selectCustomRegions }),
})

const mapDispatchToProps = {
    createOrUpdateDashboard,
    destroyDashboardStore,
    evaluateWidget,
    initializeDashboard,
    loadCustomRegions,
    loadDashboard,
    popPage,
    reconcileDashboardLayout,
    removeFromDashboardLayout,
    segueToUrl,
    sendAction,
    setDashboardsValues,
    submitWidgetTemplateSelection,
    updateUserdata,
}

export default connect(mapStateToProps, mapDispatchToProps)(withImmutablePropsToJS(Dashboard))
